import axios from 'axios';
import { API_BASE_URL } from '../utils/apiConfig';
import { PaginatedResponse } from '../types/api';

export interface CategoryApiResponse {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
  created_by: number | null;
  created_by_name: string | null;
}

export interface CategoryCreateRequest {
  name: string;
  description?: string;
}

export interface CategoryUpdateRequest {
  name?: string;
  description?: string;
}

export interface GetCategoriesParams {
  search?: string;
  page?: number;
  page_size?: number;
}

export const categoriesApi = {
  async getCategories(params?: GetCategoriesParams): Promise<PaginatedResponse<CategoryApiResponse>> {
    const response = await axios.get(`${API_BASE_URL}/categories/`, { params });
    if (Array.isArray(response.data)) {
      return {
        results: response.data,
        count: response.data.length,
        next: null,
        previous: null,
      };
    }
    return {
      results: response.data.results || [],
      count: response.data.count || 0,
      next: response.data.next || null,
      previous: response.data.previous || null,
    };
  },

  async getAllCategories(): Promise<CategoryApiResponse[]> {
    const results: CategoryApiResponse[] = [];
    let page = 1;
    let hasMore = true;
    while (hasMore) {
      const response = await axios.get(`${API_BASE_URL}/categories/`, {
        params: { page, page_size: 100 },
      });
      if (Array.isArray(response.data)) {
        results.push(...response.data);
        hasMore = false;
      } else {
        results.push(...(response.data.results || []));
        hasMore = !!response.data.next;
        page++;
      }
    }
    return results;
  },

  async createCategory(data: CategoryCreateRequest): Promise<CategoryApiResponse> {
    const response = await axios.post(`${API_BASE_URL}/categories/`, data);
    return response.data;
  },

  async updateCategory(id: number, data: CategoryUpdateRequest): Promise<CategoryApiResponse> {
    const response = await axios.patch(`${API_BASE_URL}/categories/${id}/`, data);
    return response.data;
  },

  async deleteCategory(id: number): Promise<void> {
    await axios.delete(`${API_BASE_URL}/categories/${id}/`);
  },
};
